"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eq = void 0;
const JSON_1 = require("../../JSON");
function eq(a, b) {
  return a === b ? true : (0, JSON_1.isArray)(a) && (0, JSON_1.isArray)(b) ? arrayEq(a, b) : (0, JSON_1.isObject)(a) && (0, JSON_1.isObject)(b) ? objectEq(a, b) : false;
}
exports.eq = eq;
function arrayEq(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a !== b && !eq(a[i], b[i])) {
      return false;
    }
  }
  return true;
}
function objectEq(a, b) {
  let aKeysLen = 0;
  for (let key in a) {
    aKeysLen += 1;
    if (!(key in b)) {
      return false;
    }
    if (!eq(a[key], b[key])) {
      return false;
    }
  }
  const bKeys = Object.keys(b);
  return bKeys.length === aKeysLen;
}